import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  SimpleGrid,
  Text,
} from "@chakra-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  useStoreActions,
  // useStoreState
} from "easy-peasy";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Profile from "../../../../../static/assets/icons/Profile/Profile.png";
import CardFooter from "../CardFooter";

const pixelRatio = window.devicePixelRatio || 1;
function getResizedCanvas(canvas, newWidth, newHeight) {
  const tmpCanvas = document.createElement("canvas");
  tmpCanvas.width = newWidth;
  tmpCanvas.height = newHeight;

  const ctx = tmpCanvas.getContext("2d");
  ctx.drawImage(
    canvas,
    0,
    0,
    canvas.width,
    canvas.height,
    0,
    0,
    newWidth,
    newHeight
  );

  return tmpCanvas;
}

// function generateDownload(previewCanvas, crop) {
//   if (!crop || !previewCanvas) {
//     return;
//   }

//   const canvas = getResizedCanvas(previewCanvas, crop.width, crop.height);

//   canvas.toBlob(
//     (blob) => {
//       const previewUrl = window.URL.createObjectURL(blob);

//       const anchor = document.createElement("a");
//       anchor.download = "cropPreview.png";
//       anchor.href = URL.createObjectURL(blob);
//       anchor.click();

//       window.URL.revokeObjectURL(previewUrl);
//     },
//     "image/png",
//     1
//   );
// }

function getImageUrl(previewCanvas, crop) {
  const canvas = getResizedCanvas(previewCanvas, crop.width, crop.height);
  return canvas.toDataURL("image/jpg");
}

function Resume() {
  //
  //   // const index = useStoreState(state => state.profile.index);
  const { setResume } = useStoreActions((actions) => ({
    setResume: actions.setResume,
  }));
  // const resume = useStoreState(state => state.profile.resume);
  const [isDone, setDone] = useState(false);

  const [resumeState, setResumeState] = useState({
    image: null,
    resumeFile: null,
  });
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);

  const [croppedImg, setCroppedImg] = useState(null);

  const [crop, setCrop] = useState({
    unit: "px",
    width: 300,
    aspect: 1 / 1,
  });

  const onSelectImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        setResumeState({ ...resumeState, image: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
    setDone(isDone ? !isDone : isDone);
  };

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        setResumeState({
          ...resumeState,
          resumeFile: reader.result,
        })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
    // console.log(e.target.files);
  };

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  useEffect(() => {
    if (!croppedImg || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = croppedImg;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  }, [croppedImg]);

  const saveNHandler = () => {
    setResume(resumeState);
  };

  return (
    <Box p="10">
      <Text fontSize="2xl">Upload</Text>
      <Divider />
      <SimpleGrid
        alignItems="center"
        minChildWidth="120px"
        spacing="1em"
        p="10"
      >
        {resumeState.image !== null ? (
          <Image src={resumeState.image} size="200px" rounded="full" />
        ) : (
          <Box
            backgroundColor="#efefef"
            maxWidth="100px"
            padding="1.25em"
            borderRadius="50%"
          >
            <Image src={Profile} />
          </Box>
        )}
        <input type="file" accept="image/*" onChange={onSelectImage} />
      </SimpleGrid>

      {resumeState.image && (
        <Box
          rounded="md"
          p="5"
          backgroundColor="#eeeeee"
          display={isDone ? "none" : ""}
        >
          <Flex justify="space-between" align="center">
            <Text>Preview Tab</Text>
            <Button
              variantColor="green"
              onClick={() => {
                setDone(!isDone);
                let img = getImageUrl(previewCanvasRef.current, croppedImg);
                setResumeState({ ...resumeState, image: img });
                // console.log(img);
              }}
            >
              Done
            </Button>
          </Flex>
          <Divider />
          <canvas
            ref={previewCanvasRef}
            style={{
              width: Math.round(croppedImg?.width ?? 0),
              height: Math.round(croppedImg?.height ?? 0),
            }}
          />
          <Divider />
          <ReactCrop
            locked
            src={resumeState.image}
            crop={crop}
            onImageLoaded={onLoad}
            onComplete={(c) => setCroppedImg(c)}
            onChange={(c) => setCrop(c)}
          />
        </Box>
      )}
      <Divider />
      <SimpleGrid minChildWidth="120px" spacing="1em" p="10">
        <Flex direction="column">
          <Text fontSize="lg">Attach Resume</Text>
          <Text color="grey" fontSize="md">
            ( File Format PDF, DOC, DOCS )
          </Text>
        </Flex>
        <Flex direction="column">
          <input type="file" onChange={onSelectFile} />
          <Text color="grey" fontSize="md">
            Upload New File to Update Existing Resume
          </Text>
        </Flex>
      </SimpleGrid>
      {/* <Button onClick={() => generateDownload(previewCanvasRef.current, croppedImg)}>
                Downlo>ad
            </Button */}

      <CardFooter snHandler={() => saveNHandler} />
    </Box>
  );
}

export default Resume;
